import RestService from "../RestService";
import REST_URLS from "../RestUrls.constants";

const base = REST_URLS.COURSE_RELATIONSHIP.baseUrl;
const endpoints = REST_URLS.COURSE_RELATIONSHIP.endpoints;

export default {
  getCourseRelationships() {
    let url = base + endpoints.courseRelationships;
    return RestService.getRequest(url);
  },

  getCourseRelationshipsForUser(user) {
    let url =
      base + endpoints.courseRelationshipsForUser.replace("{user}", user);
    return RestService.getRequest(url);
  },

  createCourseRelationship(
    courseId,
    studentEmail,
    tutorEmail,
    courseDuration,
    startDate,
    sessionStartTime,
    sessionEndTime
  ) {
    let url = base + endpoints.createCourseRelationship;
    return RestService.postRequest(url, {
      courseId,
      studentEmail,
      tutorEmail,
      courseDuration,
      startDate,
      sessionStartTime,
      sessionEndTime
    });
  },

  updateCourseRelationship(data) {
    let url = base + endpoints.updateCourseRelationship;
    return RestService.putRequest(url, data);
  },

  deleteCourseRelationship(_id) {
    let url = base + endpoints.deleteCourseRelationship;
    return RestService.deleteRequest(url, { _id });
  },

  setNextSessionDate(_id, clearNextSession, date, startTime, endTime) {
    let url = base + endpoints.setNextSessionDate;
    return RestService.putRequest(url, {
      _id,
      clearNextSession,
      date,
      startTime,
      endTime
    });
  },

  createSessionReport(_id, sessionReport) {
    let url = base + endpoints.createSessionReport;
    return RestService.postRequest(url, { _id, sessionReport });
  },

  updateSessionReport(_id, sessionReport) {
    let url = base + endpoints.updateSessionReport;
    return RestService.postRequest(url, { _id, sessionReport });
  },

  deleteSessionReport(courseId, sessionId) {
    let url = base + endpoints.deleteSessionReport;
    return RestService.deleteRequest(url, { courseId, sessionId });
  }
};
